import styled from 'styled-components';

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 1.5rem 0;
`;

/* O `&&` dobra a especificidade de propósito: as páginas que usam este
   componente têm regras como `form button { padding: 0 10rem }`, que de outro
   modo esticariam o switch por serem mais específicas que uma classe só. */
const Track = styled.button`
  && {
    position: relative;
    flex-shrink: 0;
    width: 4.4rem;
    height: 2.4rem;
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    border-radius: 1.2rem;
    cursor: pointer;
    background-color: ${({ isOn }) =>
      isOn ? 'var(--primary-color)' : '#c4c4c4'};
    transition: background-color 0.2s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0.3rem;
    left: ${({ isOn }) => (isOn ? '2.3rem' : '0.3rem')};
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    background-color: #fff;
    transition: left 0.2s;
  }

  &:focus-visible {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
`;

const SwitchLabel = styled.label`
  color: var(--font-color);
  font-size: 1.4rem;
  cursor: pointer;
  user-select: none;
`;

export { SwitchRow, Track, SwitchLabel };
